import { Link } from "react-router-dom";
import { SITE, CONTACT, NAV, waLink, mailtoLink } from "@/data/site";
import { THEMES } from "@/data/themes";
import { LOCATIONS } from "@/data/locations";
import { Wordmark } from "./Wordmark";
import { ContourField } from "./ContourField";

export const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-[#181A1B] text-[#F7F5F0]" data-testid="site-footer">
      <ContourField className="absolute -right-20 bottom-0 h-[380px] w-[620px] opacity-[0.12]" stroke="#F7F5F0" opacity={0.5} />

      <div className="ss-container relative py-20 lg:py-28">
        <div className="max-w-3xl">
          <p className="ss-overline text-[#F7F5F0]/50 mb-6">{SITE.tagline}</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] text-[#F7F5F0]">
            {SITE.closing}
          </h2>
        </div>

        <div className="mt-16 lg:mt-20 grid grid-cols-2 md:grid-cols-4 gap-10 lg:gap-12">
          <div>
            <p className="ss-overline text-[#F7F5F0]/40 mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="ss-link text-[0.9rem] text-[#F7F5F0]/80" data-testid={`footer-nav-${n.label.toLowerCase().replace(/[^a-z]+/g,"-")}`}>
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="ss-overline text-[#F7F5F0]/40 mb-5">Intelligence</p>
            <ul className="space-y-3">
              {THEMES.slice(0, 5).map((t) => (
                <li key={t.slug}>
                  <Link to={`/intelligence/${t.slug}`} className="ss-link text-[0.9rem] text-[#F7F5F0]/80">
                    {t.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="ss-overline text-[#F7F5F0]/40 mb-5">Locations</p>
            <ul className="space-y-3">
              {LOCATIONS.slice(0, 6).map((l) => (
                <li key={l.slug}>
                  <Link to={`/locations/${l.slug}`} className="ss-link text-[0.9rem] text-[#F7F5F0]/80">
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="ss-overline text-[#F7F5F0]/40 mb-5">Contact</p>
            <ul className="space-y-3 text-[0.9rem] text-[#F7F5F0]/80">
              <li>
                <a href={waLink()} target="_blank" rel="noopener noreferrer" className="ss-link" data-testid="footer-whatsapp">
                  WhatsApp · {CONTACT.whatsappDisplay}
                </a>
              </li>
              <li>
                <a href={`tel:+${CONTACT.whatsapp}`} className="ss-link" data-testid="footer-phone">
                  Phone · {CONTACT.whatsappDisplay}
                </a>
              </li>
              <li>
                <a href={mailtoLink()} className="ss-link" data-testid="footer-email">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <Link to="/advisory" className="ss-link">Request an assessment</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#F7F5F0]/15 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <Wordmark tone="light" variant="primary" className="h-[26px] sm:h-[30px]" />
          <div className="text-[0.75rem] text-[#F7F5F0]/45 font-body space-y-1 md:text-right">
            <p>Independent property intelligence & buyer-side advisory · Uttarakhand, India</p>
            <p className="font-mono-ss tracking-wider">
              © {new Date().getFullYear()} Selling Sunsets · {SITE.domain}
            </p>
            <p className="flex md:justify-end gap-4 pt-2">
              <Link to="/privacy" className="ss-link">Privacy</Link>
              <Link to="/about" className="ss-link">About</Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
